// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"ea9a53db045650b2","6831":"ea7d65d23f8828ba","8503":"fe58ee3f470e6e64","9683":"9366d942c0502ae0"}[chunkId] + ".js";
};